@if (showErrors) {
  <ion-list>
    @for (errorText of errorTexts; track errorText) {
      <ion-item color="danger">
        {{ errorText }}
      </ion-item>
    }
  </ion-list>
}
